import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()

export class HttpCancelService {
    private pendingHttpRequests$ = new Subject<void>();
    constructor() { }
    public cancelPendingRequests() {
        this.pendingHttpRequests$.next();
    }
    public onCancelPendingRequests() {
        return this.pendingHttpRequests$.asObservable();
    }
}
